import React, { useContext, useRef } from 'react';
import EventEmitter from 'eventemitter3';

const AppEventsContext = React.createContext<EventEmitter>(undefined);

export const AppEventsProvider: React.FC = ({ children }) => {
  const { current: appEvents } = useRef(new EventEmitter());
  return <AppEventsContext.Provider value={appEvents}>{children}</AppEventsContext.Provider>;
};

export const useAppEvents = () => ({ appEvents: useContext(AppEventsContext) });
